(function() {
  'use strict';

  angular.module('blocks.errorHandler', []);
})();
